import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=04f8cba5&scoped=true"
import script from "./wechatBind.vue?vue&type=script&lang=js"
export * from "./wechatBind.vue?vue&type=script&lang=js"
import style0 from "./wechatBind.vue?vue&type=style&index=0&id=04f8cba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8cba5",
  null
  
)

export default component.exports